import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import { FormikInput, FormikSelect, FormikTextArea, FormikSearchSelect } from "../../../components/formik-components";
import { respEnum, PushNotificationTypeEnum, UnAuthorizedMessageForKey } from "../../../constants/appConstant";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import '../../../assets/nascent.css';

const FormikInitialValues = {};

const formikValidation = yup.object({
    content: yup.string().required("Content is required").max(120, "Content must not exceed 120 characters"),
    title: yup.string().required("Title is required").max(50, "Title must not exceed 50 characters"),
    type: yup.number().required("Type is required"),
    key: yup.string().max(20, "Title must not exceed 20 characters"),
});


const AddNotifications = ({ id, onClose, open, setOpen }) => {
    const formikRef = useRef();
    const dialogRef = useRef();
    const navigate = useNavigate();
    const [isFormikInitialized, setIsFormikInitialized] = useState(false);
    const [clubs, setClubs] = useState([]);

    useEffect(() => {
        setIsFormikInitialized(open);
    }, [open]);

    const onSubmitData = async (d, action) => {

        if (+d.type == PushNotificationTypeEnum.Club_Notification && !d.clubId) {
            Common.showToast("Club Is Required if Notification Type Club Notification");
            return;
        }

        if (+d.type == PushNotificationTypeEnum.Club_Notification) {
            d.referenceId = d.clubId;
        }

        let data = {
            ...d,
            id, 
            referenceId: +d.referenceId,
        };
        let response = await Common.ApiService.getInstance().request(
            "SendPushNotificationToUsers",
            data,
            "POST"
        );
        action.setSubmitting(false);
        debugger
        if (response) {
            if (response.status === respEnum.Success) {
                Common.showToast(response.message, "Success", "success");
                onClose(response.data);
                setOpen(false);
                if (!onClose) {
                    navigate("/app/notification", { replace: true });
                }
                
            }
            if (response == UnAuthorizedMessageForKey) {
                setOpen(false);
            }
        }
    };

    const getDataInfo = async () => {
        let response = await Common.ApiService.getInstance().request(
            `GetNotificationData?id=${id}`
        );
        if (response.status === respEnum.Success && response.data.length > 0) {
            formikRef.current.setValues(response.data[0]);
        }
    };

    useEffect(() => {
        if (id) {
            getDataInfo();
        }
    }, [id]);

    useEffect(() => {
        getClubs();
    }, []);

    const getClubs = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetClubsDDL"
            );
            const data = [
                { id: null, name: "Select Club" },
                ...(response?.data ?? []),
            ];

            setClubs(data);
        });
    };

    return (
        <div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    <Button
                        //onClick={() => setOpen(true)}
                        size="sm"
                        variant="primary"
                        className="flex items-center gap-2"
                    >
                        <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
                        Add Notification
                    </Button>
                </DialogTrigger>
                <DialogContent 
                    ref={dialogRef}
                    className="custom-dialog"
                >
                    <DialogHeader>
                        <DialogTitle className="text-base font-medium ">
                            {!id ? "Add" : "Update"} Notification
                        </DialogTitle>
                    </DialogHeader>

                    <div className="text-sm text-default-500  space-y-2">
                        <Formik
                            innerRef={formikRef}
                            onSubmit={onSubmitData}
                            initialValues={FormikInitialValues}
                            validationSchema={formikValidation}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {(formikProps) => (
                                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                                    <div className="col-span-1">
                                        <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"key"}
                                                    label={"Key"}
                                                    placeholder={"Key"}
                                                    maxLength="20"
                                                />
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"title"}
                                                    label={"Title"}
                                                    placeholder={"Title"}
                                                    maxLength="50"
                                                />
                                            </div>
                                          
                                            <div className="flex flex-col gap-2">
                                                <FormikSelect
                                                    formikProps={formikProps}
                                                    name={"type"}
                                                    placeholder={"Type"}
                                                    label={"Type"}
                                                    data={[
                                                        { id: PushNotificationTypeEnum.Promotion, name: "Promotion" },
                                                        { id: PushNotificationTypeEnum.Alert, name: "Alert" },
                                                        { id: PushNotificationTypeEnum.Reminder, name: "Reminder" },
                                                        { id: PushNotificationTypeEnum.Club_Notification, name: "Club Notification" },
                                                    ]}
                                                />
                                            </div>

                                            {formikProps.values.type && formikProps.values.type !== PushNotificationTypeEnum.Club_Notification && (
                                                <div className="flex flex-col gap-2">
                                                    <FormikInput
                                                        formikProps={formikProps}
                                                        name={"referenceId"}
                                                        placeholder={"Enter Reference"}
                                                        label={"Reference"}
                                                        maxLength="20"
                                                    />
                                                </div>
                                            )}

                                            {formikProps.values.type === PushNotificationTypeEnum.Club_Notification && (
                                                <div className="flex flex-col gap-2">
                                                    <FormikSearchSelect
                                                        formikProps={formikProps}
                                                        name={"clubId"}
                                                        data={clubs}
                                                        placeholder={"Select Club"}
                                                        label={"Club"}
                                                    />
                                                </div>
                                            )}

                                            <div className="flex flex-col gap-2">
                                                <FormikTextArea
                                                    formikProps={formikProps}
                                                    name={"content"}
                                                    label={"Content"}
                                                    placeholder={"Content"}
                                                    maxLength="120"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                    <DialogFooter className="mt-8 gap-2">
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Close
                            </Button>
                        </DialogClose>

                        {
                         isFormikInitialized &&
                          formikRef.current && 
                         (
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikRef.current?.handleSubmit();
                                }}
                            >
                                {/*Add*/}
                                 {formikRef.current.isSubmitting
                                    ? "Saving..."
                                    : !id
                                        ? "Add"
                                        : "Update"} 
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddNotifications;
